import React, { useEffect, useState } from "react";
import PlanTableCellDay from "../PlanTableCellDay/PlanTableCellDay";
import PlanTableCellHour from "../PlanTableCellHour/PlanTableCellHour";
import { PlusIcon, XIcon, SaveIcon, UploadIcon, EyeIcon } from '@heroicons/react/outline'
import { Link } from "react-router-dom";
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'
import PlanTableCellSum from "../PlanTableCellSum/PlanTableCellSum";
import Select from 'react-select'

const MySwal = withReactContent(Swal)

const TabContent = ({ openTab, options, planData, setPlanData, sendPlan, addPlan, savePlan, noOfRows, setNoOfRows, noOfCommentRows, setNoCommentOfRows, planIndex, selectExistingClientsPlan, clients }) => {
  const plan = {
    monday: [],
    tuesday: [],
    wednesday: [],
    thursday: [],
    friday: [],
    saturday: [],
    sunday: [],
    times: [],
    comments: []
  }

  useEffect(() => {
    mapExistingPlanData(planData)
  }, [])


  const addMeal = (meal, day, index) => {
    let temp = {}
    if (planData) {
      temp = { ...planData }
    } else {
      temp = { ...plan }
    }
    temp[day][index] = meal
    setPlanData({ ...temp }, planIndex)
  }

  const removeMeal = (meal, day, index) => {
    let temp = {}
    if (planData) {
      temp = { ...planData }
    } else {
      temp = { ...plan }
    }
    temp[day][index] = null;
    setPlanData({ ...temp }, planIndex)
  }

  const setTime = (time, index) => {
    let temp = {}
    if (planData) {
      temp = { ...planData }
    } else {
      temp = { ...plan }
    }
    temp["times"][index] = time
    setPlanData({ ...temp }, planIndex)
  }

  const addComment = (comment, index) => {
    let temp = {}
    if (planData) {
      temp = { ...planData }
    } else {
      temp = { ...plan }
    }
    temp["comments"][index] = comment
    setPlanData({ ...temp }, planIndex)
  }

  const removeComment = () => {
    if (noOfCommentRows !== 0) {
      let index = noOfCommentRows - 1
      setNoCommentOfRows(index, planIndex)

      let temp = {}
      if (planData) {
        temp = { ...planData }
      } else {
        temp = { ...plan }
      }
      temp["comments"][index] = null;
      setPlanData({ ...temp }, planIndex)
    }
  }

  const mapExistingPlanData = (existingPlan) => {
    if (existingPlan) {
      let tempPlan = { ...existingPlan }
      setPlanData({ ...tempPlan }, planIndex)
      setNoCommentOfRows(tempPlan.comments.length, planIndex)
    }
  }

  const savePreview = (planData) => {
    localStorage.setItem("previewData", JSON.stringify(planData));
  }

  const showTextAreas = [...Array(noOfCommentRows)].map((elementInArray, index) => {
    return (
      <textarea key={index}
        onChange={(e) => addComment(e.target.value, index)}
        value={planData ? planData.comments ? planData.comments[index] : '' : ''}
        className="w-full flex h-24 md:h-16 lg:h-12 py-2 px-4 text-left lg:text-lg font-medium border-t border-bluePrimary border-opacity-10"
        placeholder="Unesi komentar..."></textarea>
    );
  });
  return (
    <div>

      <div className="app">
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead className="relative shadow before:absolute before:top-1/2 before:-translate-y-1/2 before:left-0 before:h-6 before:w-0.5 before:bg-blueSecondary">
              <tr>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Vreme</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Ponedeljak</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Utorak</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Sreda</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Četvrtak</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Petak</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Subota</th>
                <th className="py-4 px-2 xl:px-4 text-left bg-white font-medium whitespace-nowrap" scope="col">Nedelja</th>
              </tr>
            </thead>
            <tbody>
              {[...Array(noOfRows)].map((elementInArray, index) => {

                return (
                  <tr key={index} className="border border-t-0 border-b-1 border-gray-100 last:border-0 text-gray-700 hover:bg-bluePrimary/10  transition animate-fadeIn">
                    <PlanTableCellHour existingTime={planData && planData["times"] && planData["times"][index] ? planData["times"][index] : null} timeIndex={index} setTime={setTime} />
                    <PlanTableCellDay existingRecipes={planData && planData["monday"] && planData["monday"][index] ? planData["monday"][index] : null} options={options} day={"monday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} />
                    <PlanTableCellDay existingRecipes={planData && planData["tuesday"] && planData["tuesday"][index] ? planData["tuesday"][index] : null} options={options} day={"tuesday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} />
                    <PlanTableCellDay existingRecipes={planData && planData["wednesday"] && planData["wednesday"][index] ? planData["wednesday"][index] : null} options={options} day={"wednesday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} />
                    <PlanTableCellDay existingRecipes={planData && planData["thursday"] && planData["thursday"][index] ? planData["thursday"][index] : null} options={options} day={"thursday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} />
                    <PlanTableCellDay existingRecipes={planData && planData["friday"] && planData["friday"][index] ? planData["friday"][index] : null} options={options} day={"friday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} />
                    <PlanTableCellDay existingRecipes={planData && planData["saturday"] && planData["saturday"][index] ? planData["saturday"][index] : null} options={options} day={"saturday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} />
                    <PlanTableCellDay existingRecipes={planData && planData["sunday"] && planData["sunday"][index] ? planData["sunday"][index] : null} options={options} day={"sunday"} mealIndex={index} addMeal={addMeal} removeMeal={removeMeal} />
                  </tr>
                );
              })}
              <tr className="border border-t-0 border-b-1 border-gray-100 last:border-0 text-gray-700 hover:bg-bluePrimary/10  transition animate-fadeIn">
                <PlanTableCellSum displayStats={false} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["monday"] ? [...planData["monday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["tuesday"] ? [...planData["tuesday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["wednesday"] ? [...planData["wednesday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["thursday"] ? [...planData["thursday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["friday"] ? [...planData["friday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["saturday"] ? [...planData["saturday"]] : null} />
                <PlanTableCellSum displayStats={true} existingRecipes={planData && planData["sunday"] ? [...planData["sunday"]] : null} />
              </tr>

            </tbody>
          </table>
        </div>
        <div className="flex justify-between p-4 font-medium shadow-[0_-1px_3px_0_rgba(0,0,0,0.1)]">
          <div className="flex md:items-center flex-col md:flex-row">
            <button type="button" className="button with-icon bg-blueSecondary mt-3 md:mt-0 md:mr-3" onClick={() => setNoOfRows(noOfRows + 1, planIndex)}>Dodaj <PlusIcon /></button>
            <button type="button" className="button with-icon bg-red-500 mt-3 md:mt-0" onClick={() => {
              if (noOfRows !== 0) { setNoOfRows(noOfRows - 1, planIndex) }
            }}>Obriši <XIcon /></button>
            <div className="ml-3">Kopiraj od</div>
            <div className="ml-3">
              <Select
                className='w-60'
                placeholder={'Pretraži...'}
                onChange={(item) => selectExistingClientsPlan(item.id, planIndex)}
                options={clients}
                classNamePrefix='select'
              />
            </div>
          </div>
        </div>
      </div >

      <div>
        {showTextAreas}

        <div className="flex flex-col sm:flex-row  justify-between xl:items-center p-4 font-medium shadow-[0_-1px_3px_0_rgba(0,0,0,0.1)]">
          <div className="flex md:items-center h-max flex-col md:flex-row">
            <button type="button" className="button with-icon bg-blueSecondary mt-3 md:mt-0 md:mr-3" onClick={() => setNoCommentOfRows(noOfCommentRows + 1, planIndex)}>Dodaj komentar <PlusIcon /></button>
            <button type="button" className="button with-icon bg-red-500 mt-3 md:mt-0" onClick={() => removeComment()}>Obriši Komentar <XIcon /></button>
          </div>
          <div className="flex flex-col lg:flex-row xl:items-center">
            <div className="flex flex-col xl:flex-row">
              <Link className="button with-icon bg-teal-400 mt-3 md:mt-0 lg:mr-3" to={{
                pathname: "/preview",
                state: { value: planData },
              }} onClick={() => { savePreview(planData) }} target="_blank" rel="noopener noreferrer"> Pregled <EyeIcon /></Link>
              <button type="button" className="button with-icon  bg-blueSecondary mt-3  xl:mt-0 lg:mr-3" onClick={() => addPlan(planIndex)}>Napravi novi plan <PlusIcon /></button>
            </div>
            <div className="flex flex-col xl:flex-row">
              <button type="button" className="button with-icon bg-teal-400 mt-3 lg:mt-0 xl:mr-3" onClick={() => savePlan(planIndex)}>Sačuvaj <SaveIcon /></button>
              <button type="button" className="button with-icon bg-slate-500 mt-3 xl:mt-0" onClick={() => sendPlan(planIndex)}>Pošalji <UploadIcon /></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default TabContent
